import { 
    get, 
    post 
} from './http'

// 登录页面api
export let login = p => post('/aaa', p); //登录
export let getCode = p => get('/bbb', p); //登录
export function getArticlesInfo(id) {
	return get(`/gbs/portal/articles/${id}`)
}

/**
 * 获取分类数据
 * @param {string} categoryId 分类ID
 * @param {string} apiPath API路径
 * @returns {Promise} 返回请求Promise
 */
export function getCategoryData(categoryId, apiPath = '/gbs/portal/portal/multiLevelArticle') {
  return get(`${apiPath}?categoryId=${categoryId}`);
}

/**
 * 获取列表页数据
 * @param {Object} params 请求参数
 * @param {string} params.categoryId 分类ID
 * @param {number} params.page 页码
 * @param {number} params.limit 每页条数
 * @param {string} params.title 标题过滤
 * @returns {Promise} 返回请求Promise
 */
export function getNewsList(params) {
  const { categoryId, page = 1, limit = 10, title = '' } = params;
  return get(`/gbs/portal/portal/newsPage?limit=${limit}&page=${page}&categoryId=${categoryId}&title=${title}`);
}

